{
    "name": "Rice",
    "binomial_name": "Oryza sativa",
    "common_names": [
        "Rice",
        "Asian Rice"
    ],
    "description": "Rice is the seed of the grass species Oryza sativa. It is a cereal grain that can come in many shapes, colors, and sizes. Rice requires ample water and is labor-intensive to cultivate. Water-controlling terrace systems enable it to be grown almost anywhere. The traditional method of cultivating rice is to flood the fields during or after setting the young seedlings. Rice can be grown without flooding, but flooding simplifies weed and pest control.",
    "sun_requirements": "Full Sun",
    "sowing_method": "Seedlings",
    "spread": 0,
    "row_spacing": 0,
    "height": 0,
    "growing_degree_days": 0,
    "companions": [],
    "image": "/crops/images/rice.jpg",
    "icon": "/crops/icons/rice.avif"
}